import type { ReactNode } from 'react'
import { Header } from './Header'

interface LayoutProps {
  children: ReactNode
  /** when true, the main container fills the full viewport width instead of the default 7xl cap */
  wide?: boolean
}

export const Layout = ({ children, wide = false }: LayoutProps) => {
  const widthClass = wide ? 'w-full' : 'max-w-[1440px] mx-auto'
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Header wide={wide} />
      <main className={`${widthClass} px-4 sm:px-6 lg:px-8 py-4 sm:py-8`}>{children}</main>
    </div>
  )
}
